module.exports = __webpack_public_path__ + "media/img/vca/categories/risingstar-c6205f03d265f3816c973b456fd87bfe.png";